import { HTMLRenderer } from '@bts-web/core-features/common';
import { css } from '@bts-web/utils-style-engine';
import { FC } from 'react';

export const PendingContent: FC<{
  subtitleMessage: string;
}> = ({ subtitleMessage }) => {
  return (
    <p
      className={css({
        fontSize: 'body.medium',
        color: 'neutrals.text_secondary',
        '& [data-element="markdown-style"]': {
          color: 'neutrals.text_primary',
        },
      })}
      aria-label="pending content"
    >
      <HTMLRenderer>{subtitleMessage}</HTMLRenderer>
    </p>
  );
};
